import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, Eyebrow } from "./Reveal";

const FAQ = [
  { q: "Valóban fix az ár?", a: "Igen. Az írásos ajánlatban szereplő végösszeg a felmérés után nem változik – rejtett vagy utólagos költségek nincsenek." },
  { q: "Látni fogják a szomszédok, hogy takarítócég érkezett?", a: "Jelölés és felirat nélküli gépjárművekkel érkezünk, és csendben, diszkréten dolgozunk." },
  { q: "Ki kell töltenem a valódi nevemet?", a: "Nem szükséges. Az ajánlatkérő űrlap álnévvel is kitölthető – csak egy telefonszámra van szükségünk a visszahíváshoz." },
  { q: "Milyen gyorsan reagálnak?", a: "Az ajánlatkérést követően 1 órán belül visszahívjuk a részletekkel. Sürgős esetben hívjon minket közvetlenül." },
  { q: "Jelen kell lennem a munkavégzésnél?", a: "Nem feltétlenül. Az egyeztetés után a kulcsátadást és a munkát is rugalmasan megoldjuk, a végén átadjuk a tiszta ingatlant." },
];

export const Faq = () => (
  <section id="gyik" data-testid="faq-section" className="py-20 sm:py-28">
    <div className="mx-auto grid max-w-7xl gap-10 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <Reveal className="lg:col-span-4">
        <Eyebrow>GYIK</Eyebrow>
        <h2 className="font-display mt-5 text-3xl font-black leading-[1.05] tracking-tight text-[var(--navy)] sm:text-5xl">Gyakori kérdések</h2>
      </Reveal>
      <Reveal delay={0.08} className="lg:col-span-8">
        <Accordion type="single" collapsible className="divide-y divide-[var(--navy)]/10 border-y border-[var(--navy)]/10">
          {FAQ.map((f, i) => (
            <AccordionItem key={f.q} value={`f${i}`} className="border-0">
              <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="font-display py-6 text-left text-lg font-bold text-[var(--navy)] hover:no-underline sm:text-xl">{f.q}</AccordionTrigger>
              <AccordionContent className="pb-6 text-base leading-relaxed text-[var(--muted)]">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
